import { i18nFn, ReferralsDTO, useSpringBigStore, useTheme } from '@springbig/shared';
import { Box, HStack, Center } from 'native-base';
import ReferRewards from '~/pages/refer/components/ReferRewards';
import React from 'react';
import { useToast } from '~/hooks/toast';
import { useCopyToClipboard } from 'usehooks-ts';
import QrCode from '~/shared/QrCode';
import { Caption } from '~/shared/Typography';
import { Button, Card } from '~/shared/Theme';

type ReferralsProps = {
    data: ReferralsDTO;
    t: i18nFn;
};

export const Referrals = ({ data, t }: ReferralsProps) => {

    const { member } = useSpringBigStore();
    const { successToast } = useToast();
    const [_, copy] = useCopyToClipboard();
    const { primary, } = useTheme();

    const handleClipboard = (_text: string) => {

        copy(_text);
        successToast(t('homepage.referrals.copiedLink'));
    };

    return (
        <Card space={2} hasShadow>
            <Caption
                text={'homepage.referrals.title'}
                fontSize={'lg'}
                bold
                textAlign={'center'}
            />
            {
                member &&
                member.referrals.has_referred_offer &&
                member.referrals.referred_offer_name &&
                <ReferRewards member={member} />
            }
            <HStack
                alignItems={'center'}
                justifyContent={'space-between'}
                space={4}
            >
                <Card
                    secondary
                    alignItems="center"
                    p={2}
                    minW={24}
                    flex={1}
                >
                    <Caption
                        text={'homepage.referrals.friendsReferred'}
                        textAlign={'center'}
                    />
                    <Caption bold fontSize={'xl'}>
                        { data.referred_count?.toString() }
                    </Caption>
                </Card>
                <Center position={'relative'}>
                    <Box w="140px" h="140px" justifyContent="center" alignItems="center" p={4}>
                        <QrCode value={member?.referrals?.link || 'www.google.com'} />
                    </Box>

                    {['top-left', 'top-right', 'bottom-left', 'bottom-right'].map((corner) => (

                        <Box
                            key={corner}
                            position="absolute"
                            w="30px"
                            h="30px"
                            borderColor={primary}
                            borderWidth={4}
                            {...(corner.includes('top') && { top: 0, borderBottomWidth: 0 })}
                            {...(corner.includes('bottom') && { bottom: 0, borderTopWidth: 0 })}
                            {...(corner.includes('left') && { left: 0, borderRightWidth: 0 })}
                            {...(corner.includes('right') && { right: 0, borderLeftWidth: 0 })}
                        />
                    ))}
                </Center>
                <Card
                    secondary
                    alignItems={'center'}
                    p={2}
                    minW={24}
                    flex={1}
                >
                    <Caption
                        text={'homepage.referrals.linkCopied'}
                        textAlign={'center'}
                    />
                    <Caption bold fontSize={'xl'}>
                        { data?.referred_rewards_count?.toString() }
                    </Caption>
                </Card>
            </HStack>
            <Caption
                text={'homepage.referrals.description'}
                textAlign={'center'}
            />
            <Button
                mx={'auto'}
                onPress={() => handleClipboard(member?.referrals?.link || '')}
                text={'homepage.referrals.copyReferralLink'}
            />
        </Card>
    );
};
